import React, { Component } from "react";
import "./information.less";
import Footer2 from "../../../components/webfooter2/webFooter2";

import {Icon} from "antd";

export default class success extends Component {
	constructor(props) {
		super(props);
		this.state = {
			footer: {
				title: "立即加入我们吧",
				phone: "400-9958-578",
			},
			list1: [
				{
					img: "",
					title: "深圳：区块链发票项目获市长质量奖金奖",
					time: "2019-06-07",
					content:[
						"6月27日，2019年度深圳市市长质量奖公布，国家税务总局深圳市税务局区块链电子发票项目获得市长质量奖服务类金奖。","据了解，市长质量奖是深圳市人民政府设立的全市最高质量荣誉，授予在推动经济、文化、社会、生态、管理和服务质量提升上成绩突出，具有显著示范带动作用，对深圳质量建设作出积极贡献的组织、项目。该奖为年度奖，分为经济、文化、社会、生态、管理和服务六大类，每个类别分设金、银、铜奖，其中金奖、银奖各1名。",'诞生于2018年的区块链电子发票为纳税人提供了便捷、高效、绿色的发票服务，成为深圳市优化税收营商环境的“金字招牌”，获得社会广泛好评。','率先试点，2018年开出全国首张区块链电子发票','据深圳市税务局副局长李伟介绍，深圳市税务部门按照国家税务总局王军局长关于加快区块链技术在税务领域研究应用的指示，联合腾讯公司设立“智税”创新实验室，打破传统发票管理思维，开始探索用区块链技术破解发票管理和服务难题。在得到国家税务总局同意开展应用试点工作的批复后，深圳市税务局抢抓机遇、积极探索，于2018年8月在全国率先试点，先行示范，推动区块链电子发票系统项目在深圳落地生根。','2018年8月10日，全国首张区块链电子发票在深圳国贸旋转餐厅开出，深圳由此成为全国首个应用区块链电子发票的城市。区块链电子发票便利、易保存的特点以及不限额、不限量在线用票等优势极大地方便了个人和企业。','累计开票2440万张，区块链发票方便百姓生活','区块链电子发票系统项目聚焦发票管理中的“痛点、难点、堵点”问题，紧紧围绕“发票资产化、数据价值化”的核心理念，从制度规范、流程设计、风险防控三方面入手，联通税收大数据平台、电子税务局，全力打造区块链电子发票服务体系，将发票的开具、流转、报销和申报的全流程上链，实现了“交易即开票”“开票即报销”“发票即数据”，每一张发票都可查、可验、可信、可追溯、可管控，大大减少了开票企业、消费者的时间成本和人力成本，降低了用票企业的财务管理风险和涉税风险。','2018年8月~2020年6月，深圳市税务局累计开出区块链电子发票2440万张，开票金额267亿元，覆盖公共交通、政务民生、金融保险、零售餐饮、教育医疗等领域116个行业17000户纳税人。区块链电子发票实现了从注册、领票、开票到报销的全流程线上化，全面助力深圳市纳税人疫情期间“非接触式”办税。','今年4月，恒大地产位于深圳坪山的一处楼盘开出全国首张不动产销售区块链电子发票。取得这张发票的购房者是一位在深圳打拼10余年的男士，这套房子的发票存在他的手机里。对于购房人而言，区块链电子发票用电子形式保存，可以随时打印，不用担心纸质发票丢失损坏等问题。','如今在深圳，交通出行差旅费报销不再需要“贴发票”，市民可体验到“链上开票”“开票即报销”的快捷；外出就餐开票不用“排长队”，一键申请，即已开票；超市购物无须“手写抬头、机打发票”，付款后1分钟内实现“交易即开票”。区块链电子发票给百姓生活带来实实在在的方便。','打造“税务—产业”联盟链，进一步扩大区块链应用范围','在区块链电子发票推广应用基础上，2020年5月9日，深圳市税务局与已拥有企业区块链的腾讯集团、平安集团、中装建设集团、欣旺达电子股份有限公司等企业签署合作框架协议，共同打造“税务—产业”联盟链。','在深圳市税务局发布的《关于建设“税务—产业”联盟链支持实体经济、服务中小微企业的十项措施》中，该局明确提出将为上链企业提供批量查验发票、直接开具区块链电子发票、完成一键申报、开具税务证明等便利功能，并开放链上税收数字钱包、链上“银税互动”等系统模块，进一步扩大了区块链在税企之间的应用范围。','5月9日，合作框架协议签署仪式上，现场连线了中国社会科学院副院长高培勇，他对联盟链的建设表示充分肯定：“‘税务—产业’联盟链能够打通税务链、金融链、产业链的联通壁垒，实现区块链和实体经济深度融合，促进城市间离散信息更大规模的互联互通以及生产要素在区域内有序高效流动。”','“深圳税务将坚持‘数据资产化’理念，运用区块链、大数据、云计算、人工智能等前沿技术，将数据资产作为推动税收工作质量变革、效率变革的重要生产要素，持续推进征管、服务数字化转型，努力培育税收现代化新动能。”深圳市税务局党委书记、局长张国钧说。'
					],
					org: "中国税务报",
					index:0
				},
				{
					img: "",
					title:
						"关于收费公路通行费电子票据,开具汇总等有关事项的公告",
					time: "2019-06-07",
					content:
						["为进一步规范收费公路通行费电子票据开具，便利ETC客户和受票单位电子票据财务处理，推进物流业降本增效，现将收费公路通行费电子票据开具汇总等有关事项公告如下：",'一、通行费电子票据开具对象','通行费电子票据的开具对象为办理ETC卡的客户。ETC卡的具体办理流程和相关要求，请咨询各省（区、市）ETC客户服务机构。未办理ETC卡的客户，仍按原有方式在收费站现场交纳车辆通行费和获取票据。','二、通行费电子票据分类','（一）收费公路通行费增值税电子普通发票（以下简称通行费电子发票）。通行费电子发票包括左上角标识"通行费"字样且税率栏次显示适用税率或征收率的通行费电子发票（以下简称征税发票）以及左上角无"通行费"字样，且税率栏次显示"不征税"的通行费电子发票（以下简称不征税发票）。客户通行经营性收费公路，由经营管理者开具征税发票,可按规定用于增值税进项抵扣；客户采取充值方式预存通行费，可由ETC客户服务机构开具不征税发票，不可用于增值税进项抵扣。','（二）收费公路通行费财政票据（电子）（以下简称通行费财政电子票据）。客户通行政府还贷公路，由经营管理者开具财政部门统一监制的通行费财政电子票据。通行费财政电子票据先行选择部分地区进行试点。试点期间，非试点地区暂时开具不征税发票。试点完成后，在全国范围内全面实行通行费财政电子票据。','通行费电子发票、通行费财政电子票据统称为通行费电子票据。针对收费公路分段建设、经营管理者多元等特性，为便利通行费电子票据财务处理，根据客户需求，通行费电子票据服务平台（以下简称服务平台）可按一次或多次行程为单位，在汇总通行费电子发票和通行费财政电子票据信息基础上，统一生成收费公路通行费电子票据汇总单（以下简称电子汇总单），作为已开具通行费电子票据的汇总信息证明材料。电子汇总单的汇总信息发生变更的，应重新开具电子汇总单，原电子汇总单自动作废失效，电子汇总单可通过服务平台查询。','三、通行费电子票据编码规则','（一）通行费电子发票编码规则。通行费电子发票的发票代码为12位，编码规则：第1位为0，第2～5位代表省、自治区、直辖市和计划单列市，第6～7位代表年度，第8～10位代表批次，第11～12位为12。发票号码为8位，按年度、分批次编制。通行费电子发票票样见附件1。','（二）通行费财政电子票据编码规则。通行费财政电子票据的票据代码为8位，编码规则：第1～2位代表通行费财政电子票据监管机构行政区划编码，第3～4位代表通行费财政电子票据分类编码，第5～6位代表通行费财政电子票据种类编码，第7～8位代表通行费财政电子票据年度编码。票据号码为10位，采用顺序号，用于反映通行费财政电子票据赋码顺序。通行费财政电子票据票样见附件2。','（三）电子汇总单编码规则。电子汇总单的单号为16位，编码规则：第1～2位为ETC用户所属发行机构的省份编码，第3～6位代表年度，第7～8位代表月份，第9～16位采用顺序号。电子汇总单式样见附件3。','四、通行费电子票据开具流程','（一）服务平台账户注册。客户登录服务平台网站www.txffp.com或"票根"APP，凭手机号码、手机验证码免费注册，并按要求设置购买方信息。客户如需变更购买方信息，应当于发生充值或通行交易前变更，确保开票信息真实准确。','（二）绑定客户ETC卡。客户登录服务平台，填写ETC卡办理时的预留信息（开户人名称、证件类型、证件号码、手机号码等），经校验无误后，完成ETC卡绑定。','（三）票据和汇总单开具。客户登录服务平台，选取需要开具票据的充值或通行交易记录，申请生成通行费电子发票、通行费财政电子票据和电子汇总单（充值交易无电子汇总单）。其中，电子汇总单可按用户需求汇总多笔通行交易信息，包括对应的行程信息、通行费电子发票和通行费财政电子票据信息、交易金额合计等。电子汇总单与其汇总的通行费电子发票、通行费财政电子票据通过编码相互进行绑定，可通过服务平台查询关联性。服务平台免费向客户提供通行费电子发票、通行费财政电子票据、电子汇总单查询、预览、下载、转发等服务。','五、通行费电子票据开具规定','（一）ETC后付费客户索取通行费电子票据的，通过经营性公路的部分，在服务平台取得由经营管理者开具的征税发票；通过政府还贷公路的部分，在服务平台取得由经营管理者开具的通行费财政电子票据。','（二）ETC预付费客户可以自行选择在充值后索取不征税发票或待实际发生通行交易后索取通行费电子票据。','客户在充值后索取不征税发票的，在服务平台取得由ETC客户服务机构全额开具的不征税发票；实际发生通行交易后，ETC客户服务机构和收费公路经营管理者均不再向其开具通行费电子票据。','客户在充值后未索取不征税发票，在实际发生通行交易后索取电子票据的，参照本条第（一）项ETC后付费客户执行。','（三）客户使用ETC卡通行收费公路并交纳通行费的，可以在实际发生通行交易后第7个自然日起，登录服务平台，选择相应通行记录取得通行费电子票据和电子汇总单；ETC预付费客户可以在充值后实时登录服务平台，选择相应充值记录取得不征税发票。','（四）服务平台应当将通行费电子票据、电子汇总单以及对应的通行明细记录归档备查。','六、通行费电子票据其他规定','（一）通行费电子票据作为电子会计凭证具有与纸质会计凭证同等法律效力，是单位财务收支和会计核算的原始凭证，在满足相关条件基础上，单位可以仅使用通行费电子票据进行报销入账归档，不再打印纸质件。具体报销入账和归档管理按照《财政部 国家档案局关于规范电子会计凭证报销入账归档的通知》（财会〔2020〕6号）执行。','（二）收费公路通行费增值税进项抵扣事项按照现行增值税政策有关规定执行。增值税一般纳税人申报抵扣的通行费电子发票进项税额，在纳税申报时应当填写在《增值税纳税申报表附列资料（二）》（本期进项税额明细）中"认证相符的增值税专用发票"相关栏次中。','（三）纳税人取得通行费电子发票后，应当登录增值税发票综合服务平台确认发票用途。税务总局通过增值税发票综合服务平台为纳税人提供通行费电子发票批量选择确认服务。','（四）单位和个人可以登录全国增值税发票查验平台（https://inv-veri.chinatax.gov.cn），对通行费电子发票信息进行查验。单位和个人可以登录全国财政电子票据查验平台（http://pjcy.mof.gov.cn），对通行费财政电子票据信息进行查验。','七、业务咨询','使用ETC卡交纳的通行费，以及ETC卡充值费开具通行费电子票据，不再开具纸质票据。客户可以拨打热线电话进行业务咨询与投诉。通行费电子发票的开票问题可拨打发票服务平台热线95022；各省（区、市）ETC客户服务机构热线电话可以登录发票服务平台查询；通行费电子发票的查验和抵扣等税务问题可拨打纳税服务热线12366。','本公告自2020年5月6日起施行。《交通运输部 国家税务总局关于收费公路通行费增值税电子普通发票开具等有关事项的公告》（交通运输部公告2020年第17号）同时废止。'],
					org: "国家税务总局",
					index:1
				},
				{
					img: "",
					title:
						"关于《国家税务总局关于增值税电子普通发票使用有关事项的公告》的解读",
					time: "2019-06-07",
					content:
						["一、发布本公告的背景是什么？","为了保障国税地税征管体制改革工作顺利推进，确保改革前后增值税电子普通发票有序衔接、平稳过渡，发布本公告。","二、新税务机构挂牌后，增值税电子普通发票版式文件上的发票监制章有何变化？","新税务机构挂牌后，国家税务总局各省、自治区、直辖市和计划单列市税务局[以下简称“各省（区、市）税务局”]将启用新的发票监制章。增值税电子普通发票（含收费公路通行费增值税电子普通发票，下同）版式文件上的发票监制章，相应修改为各省（区、市）税务局新启用的发票监制章，纳税人自建电子发票服务平台和第三方电子发票服务平台需要进行相应升级。","三、新启用的发票监制章是什么样式？","新启用的发票监制章形状为椭圆型，长轴为3厘米，短轴为2厘米，边宽为0.1厘米，内环加刻一细线，上环刻制“全国统一发票监制章”字样，中间刻制“国家税务总局”字样，下环刻制“××省（区、市）税务局”字样，下环字样例如：“江苏省税务局”、“上海市税务局”、“内蒙古自治区税务局”、“新疆维吾尔自治区税务局”。字体为楷体7磅，印色为大红色。","四、电子发票服务平台的升级工作应当于何时完成？","纳税人自建电子发票服务平台和第三方电子发票服务平台的升级工作，应当于2018年12月31日前完成。","五、电子发票服务平台升级前，发票监制章如何使用？","电子发票服务平台升级前，生成的增值税电子普通发票版式文件可以继续使用原各省、自治区、直辖市和计划单列市国家税务局的发票监制章。","六、本公告自何时起施行?","本公告自发布之日起施行。"],
					org: "国家税务总局",
					index:2
				},
				{
					img: "",
					title:
						"关于《国家税务总局关于增值税发票综合服务平台等事项的公告》的解读",
					time: "2019-06-07",
					content:
						["为贯彻落实党中央、国务院决策部署，进一步优化税收营商环境，深化税务系统“放管服”改革，便利纳税人开具和使用增值税发票，国家税务总局制发了《国家税务总局关于增值税发票综合服务平台等事项的公告》（以下简称《公告》）。现解读如下：",
						"一、通过增值税发票综合服务平台，纳税人能够获得哪些优质便捷的服务？",
						"为适应税收现代化建设需要，创新发票服务方式，提升发票管理质效，税务部门对原增值税发票选择确认平台进行升级，打造形成了增值税发票综合服务平台（以下简称“综合服务平台”）。通过这一平台，纳税人能够获得以下优质便捷的服务：",
						"一是“一站式”的发票用途确认服务。纳税人可以对其取得的增值税专用发票、机动车销售统一发票、收费公路通行费增值税电子普通发票的使用用途进行“一站式”确认，有效提升增值税扣税凭证的精细化、标准化和信息化管控水平。按照《国家税务总局关于增值税发票管理等有关事项的公告》（2019年33号）规定，自2020年2月1日起，纳税人取得符合条件的海关进口增值税专用缴款书后，也可通过综合服务平台进行用途确认。二是“集成化”的发票风险提示服务。纳税人可以对发票的开具、申报、缴税、用途确认等流转状态以及作废、红冲、异常等管理状态进行查询统计。根据查询到的风险提示信息，纳税人可以及时开展风险应对处理，有效规避因税企之间和购销双方信息不对称而产生的涉税风险和财务管理风险。三是“全票种”的发票信息下载服务。纳税人可以批量下载所取得的发票明细信息，并可据此开展批量查验、统计分析等工作，能够帮助纳税人有效提升发票电子化管理水平。目前，可以批量下载发票信息的发票种类包括增值税专用发票、增值税普通发票、增值税电子普通发票、收费公路通行费增值税电子普通发票、机动车销售统一发票、二手车销售统一发票。",
						"二、纳税人错误确认发票用途后，税务部门如何帮助纳税人进行修改和更正？",
						"按照《公告》要求，纳税人通过综合服务平台确认发票用途后，需要根据确认结果办理相关涉税业务。如果出现发票用途确认错误的情形，税务部门为纳税人提供了规范、便捷的更正服务。纳税人将发票用途误确认为申报抵扣，如果要改用于出口退税或代办退税，纳税人可以向主管税务机关提出申请。主管税务机关核实情况后，即可为纳税人调整发票用途。纳税人将发票用途误确认为申请出口退税、代办退税的，可以向主管税务机关提出申请。主管税务机关核实尚未申报出口退税并帮助纳税人回退发票电子信息后，纳税人可以通过综合服务平台重新确认发票用途。",
						"三、与其他渠道相比，通过增值税电子发票公共服务平台开具的增值税电子普通发票有哪些优点？",
						"通过增值税电子发票公共服务平台（以下简称“公共服务平台”）开具的增值税电子普通发票，具有以下优点：一是文件格式更加规范。通过公共服务平台开具的增值税电子普通发票，采用符合国家统一标准的OFD格式，做到了格式统一、安全可靠、使用便利。二是发票票样更加简洁。将“货物或应税劳务、服务名称”栏次名称简化为“项目名称”，取消了原“销售方:（章）”栏次，简化了发票票面样式。三是签章方式更加先进。采用可靠的电子签名代替原发票专用章，采用经过税务数字证书签名的电子发票监制章代替原发票监制章，更好适应了发票电子化改革的需要。",
						"需要说明的是，符合《国家税务总局关于推行通过增值税电子发票系统开具的增值税电子普通发票有关问题的公告》（2015年第84号，国家税务总局公告2018年第31号修改）附件1格式的增值税电子普通发票，在税务总局另行公告前，继续有效。",
						"四、发票票种核定事项的办结时限有什么变化？",
						"为进一步便利纳税人领用发票，保障纳税人正常生产经营活动，税务总局决定将增值税普通发票、增值税电子普通发票、收费公路通行费增值税电子普通发票、机动车销售统一发票、二手车销售统一发票票种核定事项办理时限由原来的5个工作日调整为即时办结。在便利守法纳税人的同时，为防范税收风险，营造更加规范公平的税收经济秩序，税务机关按规定确定的高风险等情形不适用此项便利措施。",
						"五、纳税人丢失增值税专用发票及机动车销售统一发票后，税务或财务管理流程有何优化？",
						"为贯彻落实党中央、国务院关于减证便民、优化服务的部署要求，税务部门不断提升“信息管税”能力和水平，已经实现了增值税专用发票及机动车销售统一发票报税信息的共享共用。纳税人丢失发票的发票联、抵扣联后，已无需前往税务机关申请开具《丢失增值税专用发票已报税证明单》，可凭相应发票的其他基本联次复印件，作为增值税进项税额的抵扣凭证、退税凭证或记账凭证。",
					],
					org: "国家税务总局",
					index:3
				},
				{
					img: "",
					title: "电子发票解决方案一般有哪些应用？",
					time: "2019-06-07",
					content:
						["伴随着手机支付的普及化，大家已享有来到数字化产生的方便快捷收益，但是在发票方面仍存在着不少问题。比如说电子发票虽已普及，但是不少企业在报销的时候仍需要纸质发票，那么电子发票解决方案一般都有哪些应用呢?",
						"以快餐连锁店为例，在就餐高峰时段，就餐消费者多种多样，集中化付钱结帐已让前台收银工作人员忙得不相往来，当消费者索取税票时，从前都是由前台收银工作人员找来纸和笔，消费者写好开税票企业名字和纳税识别号，前台接待工作人员再依据笔写的信息录入到开票系统开展开税票，由于操作步骤繁杂，人员配置不够，付钱等待的时间悠长，常常招来消费者不满意，消费者在用餐位等待开税票和结帐时，也间接性危害了餐馆的客单量，有的时候还会开错税票，废弃的税票量很大。如果采用电子发票解决方案，顾客应用手机扫一扫用餐发票上的二维码，填好开票信息递交后，电子发票服务平台就可以全自动出具电子发票，电子发票下达到该消费者的手机上或电子邮箱中。消费者不用排长队等候，前台收银工作人员也不用手输开税票，开票高效率大幅度提高，发票作废量大幅度减少，财务月底开展税票统计分析时，只需导出来归纳及可。",
						"另外就是在电商公司的应用中，税票数据信息可从电子商务平台立即导到开税票服务平台，大批量出具后立即将开票信息下达到客户的手机上或电子邮箱中，公司也不用二次邮递税票提升成本费。",
						"总而言之，电子发票因电子化、节能型、易储存、易查寻等优势，广泛运用于每个行业领域，在其中餐饮业、酒店业、营运商、电商公司、物流行业等对电子发票的要求尤其明显。",
					],
					org: "搜狐新闻",
					index:4
				},
				{
					img: "",
					title: "电子发票你了解多少？电子发票怎么开？",
					time: "2019-06-07",
					content:
						["小伙伴们，你对增值税电子发票了解吗？有使用过电子发票服务平台吗？知道电子发票基础服务费是免费的吗？不了解，不清楚？没关系！今天就来“探秘”电子发票的疑惑吧！",
						"消费者如何取得电子发票？",
						"消费者购买商品后，可以通过电子邮箱、智能手机等渠道获得企业开具的电子发票。",
						"选择开具电子发票的顾客申请退货，发票如何处理？",
						"开具电子发票的订单申请退货，原电子发票会通过系统自动冲红（原电子发票显示无效）。",
						"电子发票可以通过什么方式进行查验，如发现查验结果不相符应如何处理？",
						"消费者可以登录全国增值税发票查验平台查询电子发票真伪，也可以使用手机微信扫一扫功能扫描发票上的二维码进行自动识别。发现查验结果不相符，可向税务机关进行举报。",
						"生活中电子发票带来哪些便利？",
						"“以前在就餐高峰期时，很多顾客都要排着队等我们前台打印纸质发票，偶尔还会因打错导致发票作废。现在用上电子普通发票后，我们餐饮发票不需要一份份打印了，电子发票开具后直接发到顾客的电子邮箱，方便很多！”温州三榆开元名都大酒店财务人员赵秀秀在开出第一张电子发票后，为该便民举措点赞道。",
						"对于电子发票带来的便利，市民黄先生也是深有体会。“现在高速ETC通行费、加油站办充值卡、寄快递等都可以申请电子发票，在开票环节确实节省了很多等待的时间。”不过，黄先生也有疑问，电子发票可以报销吗？报销时是否需要打印？黑白色的电子发票是否有效呢？",
						"采访中，记者了解到，消费者获得商家提供的电子发票版式文件后，如需进行财务报销或者售后维修服务时，可自行打印电子发票。打印电子发票不需要使用发票专用纸张，普通打印纸即可。电子发票其他报销程序同现有的普通发票报销程序一样。",
						"据税务人员介绍，国家推行电子发票主要是为了降低纳税人的经营成本，方便消费者的保存和使用，同时也有利于税务部门加强征管并为税收数据的自动归集和利用创造必要的条件。目前乐清全市电商、电信、快递、公用事业等行业的电子普通发票推行工作已经稳步推开，下一步，乐清市税务局还将继续做好全行业的电子发票推广，争取2020年电子发票使用比例达到80%以上。",
					],
					org: "搜狐新闻",
					index:5
				},
			],
			list2: [
				{
					title: "如何申请和开具电子发票",
					time: "2019-06-07",
					content:
						["日常在网站上购物或者去餐厅就餐时，细心的你也许会发现，除了传统的纸质发票外，很多网站和商家也开始提供电子发票。如何申请和开具电子发票？",
						"问：什么是电子发票？",
						"答：增值税电子普通发票，是指通过增值税发票系统升级版开具、上传，通过电子发票服务平台查询、下载的电子增值税普通发票。电子发票作为合法有效的凭证，法律效力、基本用途、基本使用规定等与税务机关监制的纸质增值税普通发票相同。区别于传统纸质发票，是在原有加密防伪措施上，使用数字证书进行电子签章后供购买方下载使用。",
						"问：电子发票有何优点？",
						"答：与传统纸质发票相比，首先，纳税人申领、开具、流转、查验电子发票等都可以通过税务机关统一的电子发票管理系统在互联网上进行，发票开具更快捷、查询更方便。",
						"第二，电子发票能一直以电子形式保存，需要时再打印。因此购买方只要电子数据保存完整，即便当时不打印，以后也可以随时打印成纸质凭证。",
						"第三，在开票方经营管理方面，从传统的物理介质发展为数据电子形式，利于企业节约经营成本，特别是电商、电信、快递等开票量大的行业。",
						"另外，电子发票也打破了纸质发票作为会计记账凭证的传统，具备了发票会计档案电子记账的条件。新修订的《会计档案管理办法》规定，符合条件的电子发票可仅以电子形式保存，形成电子会计档案。以后档案逐步变成电子形式，电子发票就无需打印了。",
						"问：如何申请和开具电子发票？",
						"答：纳税人确认自己使用的税控设备是增值税发票系统升级版，然后自建或者委托第三方搭建好电子发票服务平台后，带上经办人身份证明原件及复印件、发票专用章印模，填制《纳税人领用发票票种核定表》（一式二份），到主管税务机关办税服务厅提出申请电子发票的票种核定，办理流程、所需资料与办理增值税普通发票票种核定一致。",	
						"电子发票服务平台以纳税人自建为主，也可由第三方研发提供服务平台。国家税务总局统一制定电子发票服务平台的技术标准和管理制度，并发布了国家税务总局公告2015年第53号，明确了电子发票系统数据接口规范。数据接口规范已在金税工程纳税人技术服务网（http://its.chinatax.gov.cn）上发布。",	
						"纳税人使用新系统开具电子发票，开票系统将发票信息上传税务机关，同时传输给对接的电子发票服务平台，平台按照电子发票现有机制和要求生成带纳税人签章的电子发票及其图像文件，反馈给开票方。其中电子发票上有税控签名和电子签章，不需要再另外加盖发票专用章。",	
					],
					org: "中国农业新闻网",
					index:0
				},
				{
					title: "你知道吗？这三种发票无法作废哦~",
					time: "2019-06-07",
					content:
						["日常工作中，经常会遇到退货、开具有误等情况需要作废发票的情况。有哪些发票无法作废，只能开红字，你知道吗？ ",
						"商家开出的电子发票",
						"电子发票系统不支持作废操作，发生退货、电子发票开具有误等情况，开票人应通过开具红字发票进行冲减，电子发票开具红字发票，需要与对应的物流、资金流信息一致。因为增值税电子普通发票具有可复制性，无法回收的特点，所以增值税电子普通发票一旦开具暂不能作废。开具后如发生开票有误、销货退回或销售折让等情形时，应开具红字增值税电子普通发票，无需退回增值税电子普通发票。",
						"成品油专用发票",
						"根据《国家税务总局关于成品油消费税征收管理有关问题的公告》（国家税务总局公告2018年第1号）规定，所有成品油发票均须通过增值税发票管理新系统中成品油发票开具模块开具，开具成品油发票时应遵守以下规则：开具成品油专用发票后，发生销货退回、开票有误以及销售折让等情形的，应按规定开具红字成品油专用发票。所以成品油发票开具有误，应按规定开具红字成品油专用发票。",
						"已经认证了的增值税专用发票",
						"根据《增值税专用发票使用规定》：同时具有下列情形的，为本规定所称作废条件：1.收到退回的发票联、抵扣联时间未超过销售方开票当月；2.销售方未抄税并且未记账；3.购买方未认证或者认证结果为“纳税人识别号认证不符”、“专用发票代码、号码认证不符”。根据《国家税务总局关于红字增值税发票开具有关问题的公告》（国家税务总局公告2016年第47号）规定，增值税一般纳税人开具增值税专用发票后，发生销货退回、开票有误、应税服务中止等情形但不符合发票作废条件，或者因销货部分退回及发生销售折让，需要开具红字专用发票。",
						
					],
					org: "财税网",
					index:1
				},
				{
					title: "公司开出的免税增值税电子普通发票，客户是否可以抵扣",
					time: "2019-06-07",
					content:
						["我公司是客运企业，享受疫情期间提供公共交通运输服务免征增值税优惠。我公司开出的免税增值税电子普通发票，客户是否可以抵扣?",
						"答：《财政部 税务总局海关总署关于深化增值税改革有关政策的公告》（2019年第39号）第六条规定，纳税人购进国内旅客运输服务，若未取得增值税专用发票的，可以暂以取得的增值税电子普通发票上注明的税额，从销项税额中抵扣。",
						"按照现行增值税政策规定，你公司享受免征增值税政策，向客户开具增值税电子普通发票时，应当在税率或征收率栏次填写“免税”字样，发票上不显示税额，下个环节不能据此抵扣进项。",
						],
					org: "国家税务局",
					index:2
				},
				{
					title: "小规模纳税人应如何正确开具发票",
					time: "2019-06-07",
					content:
						["增值税减免税政策出台前后，小规模纳税人应如何正确开具发票？",
						"答：增值税小规模纳税人取得应税销售收入，纳税义务发生时间在2020年2月底以前，已按3%征收率缴纳税款，但未开具发票的，在3月1日以后可以按照3%征收率补开发票。如果纳税义务发生在2月底以前，并且开具了增值税发票，发生销售折让、中止或者退回等情形需要开具红字发票的，则应按照3%征收率开具红字发票；如果开票有误需要重新开具的，应按照3%征收率开具红字发票，再重新开具正确的蓝字发票。",
						
					],
					org: "国家税务局",
					index:3
				},
				{
					title: "转登记小规模纳税人，开票哪些需注意？",
					time: "2019-06-07",
					content:
						["转登记为小规模纳税人后，开具发票有啥需要注意的特殊情况？",
						"答：为进一步支持小微企业复工复业，扶持企业渡过经营难关，近日，税务总局发文明确，将转登记政策延续一年。一般纳税人如果年销售额不超过500万元的，可在2020年底前选择办理转登记。纳税人转登记为小规模纳税人后，在发票开具方面，也有一些特殊情况需要处理。这里再帮助大家梳理一下：",
						"首先，转登记纳税人自转登记日的下期起，发生增值税应税销售行为，应当按照小规模纳税人的征收率开具增值税发票。其次，转登记纳税人在一般纳税人期间发生的增值税应税销售行为，需要开具红字发票、换开发票、补开发票的，一律按照一般纳税人期间适用的税率或者征收率开具。",
						],
					org: "国家税务局",
					index:4
				},
				{
					title: "一般纳税人取得符合规定的通行费电子发票后怎么抵扣？",
					time: "2019-06-07",
					content:
						["根据《关于收费公路通行费增值税电子普通发票开具等有关事项的公告》第四条第一款和第二款规定：增值税一般纳税人取得符合规定的通行费电子发票后，应当自开具之日起360日内登录本省(区、市)增值税发票选择确认平台，查询、选择用于申报抵扣的通行费电子发票信息；增值税一般纳税人申报抵扣的通行费电子发票进项税额，在申报纳税时应当填写在《增值税纳税申报表附列资料(二)》(本期进项税额明细)中“认证相符的增值税专用发票”相关栏次中。”",
						"答：根据《关于收费公路通行费增值税电子普通发票开具等有关事项的公告》第四条第一款和第二款规定：增值税一般纳税人取得符合规定的通行费电子发票后，应当自开具之日起360日内登录本省(区、市)增值税发票选择确认平台，查询、选择用于申报抵扣的通行费电子发票信息；增值税一般纳税人申报抵扣的通行费电子发票进项税额，在申报纳税时应当填写在《增值税纳税申报表附列资料(二)》(本期进项税额明细)中“认证相符的增值税专用发票”相关栏次中。”",
						],
					org: "国家税务局",
					index:5
				},
			],
			//openSwitch  切换
			openSwitch:true,
			obj:{
				index:'',//索引
				dic:'',// 数组标识
				item:{
					content:[]
				},  //元素
				previous:'', //上哟个
				next:''   //下一个
			},
		};
	}

	selectItem=(obj)=>{
		let {index,dic} = obj
		if(dic==1){
			obj.item = this.state.list1[index]
			try{
				obj.previous = (this.state.list1[index-1]).title
			}catch{
				obj.previous = ''
			}
			try{
				obj.next = (this.state.list1[index+1]).title
			}catch{
				obj.next = ''
			}
		}else{
			obj.item = this.state.list2[index]
			try{
				obj.previous = (this.state.list2[index-1]).title
			}catch{
				obj.previous = ''
			}
			try{
				obj.next = (this.state.list2[index+1]).title
			}catch{
				obj.next = ''
			}
		}
		this.setState({obj})
	}

	itemClick=(index,dic)=>{
		let obj ={
			index, 
			dic, 
		}
		this.setState({
			openSwitch:false,
		},()=>{
			this.selectItem(obj)
			this.scrollToAnchor()
		})
	}

	logout=()=>{
		this.setState({openSwitch:true})
	}
	//  information-content3
	scrollToAnchor = () => {
		
			// 找到锚点
			let anchorElement = document.getElementById("information-content3");
			// 如果对应id的锚点存在，就跳转到锚点
			if(anchorElement) { 
				// anchorElement.scrollIntoView({block: 'start', behavior: 'smooth'});
				window.scrollTo(0, anchorElement.offsetTop);
			 }
		
	}
	  
	setContent=(val)=>{
		let obj = this.state.obj
		if(val=='1'){
			obj.index--
		}else{
			obj.index++
		}
		this.selectItem(obj)
		this.scrollToAnchor()
	}

	render() {
		return (
			<div className="information-page">
				<div className="information-content1">
					<img
						src={require("../../../assets/img/information/banner.png")}
						alt=""
					/>
				</div>
				<div className="information-content2" style={{display:this.state.openSwitch?'flex':'none'}}>
					<div>
						<h1>
							行业动态
							<span>加载更多</span>
						</h1>
						{this.state.list1.map((item) => {
							return (
								<div className="left-item" key={item.index}  onClick={this.itemClick.bind(this,item.index,'1')}>
									<span>
										<img src={item.img} alt="图片" />
									</span>
									<div>
										<h1>{item.title}</h1>
										<h6>{item.time}</h6>
										<p>{item.content[0]}</p>
									</div>
								</div>
							);
						})}
					</div>
					<div>
						<h1>
							发票解答
							<span>加载更多</span>
						</h1>
						{
							this.state.list2.map((item)=>{
								return <div className="right-item" key={item.index} onClick={this.itemClick.bind(this,item.index,'2')}>
								<div>
									<h1>{item.title}</h1>
									<h6>{item.time}</h6>
									<p>
										{item.content[0]}
									</p>
								</div>
							</div>
							})
						}
						
					</div>
				</div>
				
				<div className="information-content3" id="information-content3" style={{display:this.state.openSwitch?'none':'flex'}}>
					<div>
						<h1><span>{this.state.obj.item.title}</span><Icon 	type="logout" onClick={this.logout} /></h1>
						<div>
							<span>{this.state.obj.item.time}</span>
							<span>作者：译名</span>
							<span>来源：{this.state.obj.item.org}</span>
						</div>
						<div>
							{
								this.state.obj.item.img?<img src={require(this.state.obj.item.img)} alt/>:null
							}
						</div>
						
						{
							(this.state.obj.item.content).map((item,index)=>{
							return <p key={index}>{item}</p>
							})
						}
					</div>
					
					<div>
					{
						this.state.obj.previous?<div ><span  onClick={this.setContent.bind(this,'1')} style={{cursor:'pointer'}}>上一条：{this.state.obj.previous}</span></div>:null
					}
					{
						this.state.obj.next?<div><span  onClick={this.setContent.bind(this,'2')} style={{cursor:'pointer'}}>下一条：{this.state.obj.next}</span></div>:null
					}
					</div>
				</div>

				<Footer2 title={this.state.footer} />
			</div>
		);
	}
}
